import { Component, OnInit, signal, Signal } from '@angular/core';
import { EffectsModule, provideEffects } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { AuthService, BubdataCommonComponent, CommonDataEffects, CommonDataModule, featureNameCommonData, FoxyLibModule, LipoMessageService, reducerCommonData, StatistikService, NovitaetenLookupService, EnvironmentService } from 'FoxxyLib';
import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { FloatLabelModule } from 'primeng/floatlabel';
import { AngleDoubleRightIcon } from 'primeng/icons/angledoubleright';
import { InputTextModule } from 'primeng/inputtext';
import { NovitaetendiagrammSomaComponent } from './components/novitaetendiagramm-soma/novitaetendiagramm-soma.component';
import { SomaRechnerCockpitComponent } from './components/soma-rechner-cockpit/soma-rechner-cockpit.component';
import { DashbordNotificationsComponent } from './components/notifications/notifications.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { IAuthUser, ISortimentierenEnvironment } from 'FoxxyInterfaces';
import { ToastMessageOptions } from 'primeng/api';
import { Apollo } from 'apollo-angular';



@Component({
    selector: 'app-cockpit',
    imports: [ButtonModule, SelectModule, FloatLabelModule, InputTextModule,
        FoxyLibModule, NovitaetendiagrammSomaComponent, SomaRechnerCockpitComponent, DashbordNotificationsComponent],
    providers: [Apollo],
    templateUrl: './cockpit.component.html',
    styleUrl: './cockpit.component.scss'
})
export class CockpitComponent implements OnInit
{
  authUser: Signal<IAuthUser> = signal(null);
  lieferantenportaurl: string;

  constructor(private lipomessageService: LipoMessageService<ToastMessageOptions>,
    private authService: AuthService,
    private enVironmentService: EnvironmentService<ISortimentierenEnvironment>,
  )
  {

    this.authUser = toSignal(this.authService.getLipoUser());
    this.lieferantenportaurl = enVironmentService.environment.lieferantenPortalUrl;

  }
  ngOnInit(): void {

  }



  list = [{ name: 'Anfang', value: 1 }, { name: 'Mitte', value: 2 }, { name: 'Ende', value: 3 }];


  click(e)
  {
    this.lipomessageService.Publish(<ToastMessageOptions>{ severity: 'info',  summary : ' grretins from cockpit', detail: 'hello', escape: false }  );

  }
}
